import React from 'react';

import {
    useCurationConfigState
} from '../../../../hooks/widgetConfiguration.js';

import RIQPillInput from '../../../../components/RIQPillInput.jsx';
import QueryValidationError from '../QueryValidationError.jsx';
import FilterSuggestions from './FilterSuggestions.jsx';

import {
    RIQInfoPopover
} from '../../../../components/RIQPopover.jsx';

import {
    useVerifySearch
} from '../../hooks/useVerifySearch.js';

import {
    listeningDefinitions
} from '../enums/listeningDefinitions.jsx';

import DelayedWidgetLoad from './DelayedWidgetLoad.jsx';

const {
    excludeAuthorsTitle,
    excludeAuthorsDescription,
    excludeAuthorsFilterLabel
} = listeningDefinitions['saved-search'];

export default function AuthorsFilters() {

    const [excludedAuthor, setExcludedAuthor] = useCurationConfigState('excludeAuthor');

    const {orderedErrors} = useVerifySearch(false, {
        excludedAuthor: excludedAuthor
    });

    const excludedAuthorError = !_.isEmpty(excludedAuthor) ? _.findLast(orderedErrors, {
        group: 'excludeAuthor'
    }) : null;

    return (
        <>
            <div
                className='tlw-mx-8 tlw-mb-8'
            >
                <div
                    className='tlw-mb-2.5 tlw-text-gray-900'
                >
                    {excludeAuthorsTitle}

                    <RIQInfoPopover
                        title={excludeAuthorsTitle}
                        description={excludeAuthorsDescription}
                    />
                </div>

                <RIQPillInput
                    className='tlw-w-full'
                    pills={excludedAuthor || []}
                    setPills={setExcludedAuthor}
                    focusedPillIdx={excludedAuthorError?.idx}
                    inputUniqueId='includeAuthorsInput'
                    multiline={true}
                    operator={false}
                />
                <QueryValidationError
                    searchTermsError={excludedAuthorError}
                />
            </div>

            <DelayedWidgetLoad
                instanceId={`filter-suggestions-author`}
                showLoadingView={true}
            >
                <FilterSuggestions
                    exclusionsConfigKey='excludeAuthor'
                    dimension='author'
                    dimensionName='author'
                    label={excludeAuthorsFilterLabel}
                    resultToValue={result => {
                        let authorName = result.authorName?.[1];
                        if (!authorName) {
                            authorName = result.authorHandle?.[1];
                        }
                        if (_.startsWith(authorName, '@')) {
                            authorName = authorName.slice(1);
                        }
                        return authorName;
                    }}
                    measuresToRequest={['authorHandle', 'authorName']}
                />
            </DelayedWidgetLoad>
        </>
    );
}
